import useSWR from 'swr';

import { IAnyCampaign } from 'containers/Campaign/types';
import { IDetailResponse, IPaginatedResponse } from 'utils/types';

import { buildQuery, fetcher } from './utils';

export const useLoyaltyIdentifier = (id: number) => {
  const { data: { data } = {} } = useSWR<IDetailResponse<IAnyCampaign>>(
    id ? `/v4/dash/simple/loyalty/${id}` : null,
    fetcher
  );

  return { data };
};

export const useLoyaltyIdentifierList = (params: object, shouldFetch: boolean = true) => {
  const { data, isLoading } = useSWR<IPaginatedResponse<IAnyCampaign>>(
    shouldFetch ? `/v4/dash/simple/loyalty?${buildQuery(params)}` : null,
    fetcher
  );

  return { data: data?.data, meta: data?.meta, isLoading };
};

export const useLoyaltyIdentifierWithIds = (ids: number[] = []) => {
  const { data, isLoading } = useSWR<IPaginatedResponse<IAnyCampaign>>(
    ids.length > 0 ? `/v4/dash/simple/loyalty?id=${ids.join(',')}&limit=1000` : null,
    fetcher
  );

  return { data: data?.data, meta: data?.meta, isLoading };
};
